import React, { useState } from 'react';
import api from '../services/api';
import { Link } from 'react-router-dom';

const RequestResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const response = await api.post('password_reset/request_reset/', { email });
      setStatus('success');
      setMessage(response.data.status);
    } catch (error) {
      setStatus('error');
      setMessage('Ocorreu um erro ao processar sua solicitação. Tente novamente.');
    }
  };

  return (
    <div className="login-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div className="login-box card" style={{ width: '100%', maxWidth: '400px', padding: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', fontSize: '1.5rem', marginBottom: '10px' }}>Recuperar Senha</h2>
          <p style={{ color: 'var(--text-secondary)' }}>Informe seu e-mail para receber o link de redefinição.</p>
        </div>
        
        {status === 'success' ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ color: 'var(--success)', marginBottom: '20px', fontSize: '3rem' }}>✉️</div>
            <p style={{ marginBottom: '20px' }}>{message}</p>
            <Link to="/login" className="btn" style={{ display: 'block', textAlign: 'center' }}>Voltar para Login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>E-mail</label>
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
                placeholder="seu@email.com"
              />
            </div>
            
            {status === 'error' && (
              <div style={{ color: 'var(--danger)', marginBottom: '15px', fontSize: '0.9rem' }}>{message}</div>
            )}

            <button type="submit" className="btn" style={{ width: '100%', marginTop: '10px', padding: '12px' }} disabled={status === 'loading'}>
              {status === 'loading' ? 'Enviando...' : 'Enviar Link'}
            </button>
            
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link to="/login" style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Cancelar</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default RequestResetPassword;
